import { Component, Input } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { Config } from 'ng-otp-input/lib/models/config';

@Component({
	selector: 'app-otp-input',
	templateUrl: './otp-input.component.html'
})
export class OtpInputComponent {
	@Input() public control: UntypedFormControl;

	public otpConfig: Config = {
		length: 4,
		allowNumbersOnly: true,
		containerStyles: {
			width: '100%',
			height: 'auto',
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center',
			padding: '0 4%'
		},
		inputStyles: {
			outlineColor: 'white',
			backgroundColor: 'rgba(0, 0, 0, 0.2)',
			width: '3rem',
			height: '3rem'
		}
	};
}
